import { Avatar } from '../../../layout/Avatar.jsx';
import { Pill } from '../../../layout/Pill.jsx';
import { Icon } from '../../../layout/Icon.jsx';

function resultPill(r) {
  if (r === 'allowed') return <Pill variant="success">مقبول</Pill>;
  if (r === 'blocked') return <Pill variant="danger">مرفوض</Pill>;
  if (r === 'overstayed') return <Pill variant="warning">تجاوز</Pill>;
  if (r === 'manual_override') return <Pill variant="orange">يدوي</Pill>;
  if (r === 'subscription_expired') return <Pill variant="danger">اشتراك منتهٍ</Pill>;
  if (r === 'blocked_pending') return <Pill variant="orange">فواتير معلقة</Pill>;
  if (r === 'no_session') return <Pill variant="muted">لا جلسة</Pill>;
  return null;
}

function isRecent(at) {
  if (!at) return false;
  return Date.now() - new Date(at).getTime() < 30000;
}

export function GateCard({ gate, lastEvent, canOverride, onOverride }) {
  const online = gate.status === 'online' || gate.status === 'ready';
  const directionColor = gate.direction === 'in' ? '#DCFCE7' : gate.direction === 'out' ? '#DBEAFE' : '#FEF3C7';
  const directionStroke = gate.direction === 'in' ? '#15803D' : gate.direction === 'out' ? '#1E40AF' : '#92400E';
  const showLast = lastEvent && isRecent(lastEvent.createdAt || lastEvent.at);

  return (
    <div
      className="card p-3.5 flex flex-col gap-2"
      style={{ borderColor: !online ? '#FECACA' : '#EFE7D6' }}
    >
      <div className="flex items-center gap-3">
        <div
          className="w-12 h-12 rounded-[12px] grid place-items-center"
          style={{ background: directionColor }}
        >
          <Icon name="gate" size={24} color={directionStroke} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-bold text-[13.5px] truncate">{gate.name}</div>
          <div className="text-[11px] text-ink-3">
            {gate.direction === 'in' ? 'دخول' : gate.direction === 'out' ? 'خروج' : 'دخول/خروج'}
          </div>
        </div>
        {online ? (
          <Pill variant="success"><span className="live-dot" style={{ width: 6, height: 6 }} /> فعال</Pill>
        ) : (
          <Pill variant="danger">غير متصل</Pill>
        )}
      </div>

      {showLast ? (
        <div className="flex items-center gap-2 px-2 py-1.5 rounded-lg bg-paper-2">
          <Avatar
            src={lastEvent.child?.photoUrl}
            name={lastEvent.child?.name || lastEvent.cardUid || '?'}
            size="sm"
          />
          <div className="flex-1 min-w-0">
            <div className="text-[12px] truncate font-semibold">{lastEvent.child?.name || lastEvent.cardUid}</div>
            <div className="text-[10.5px] text-ink-3 truncate">{lastEvent.reason || ''}</div>
          </div>
          {resultPill(lastEvent.result)}
        </div>
      ) : null}

      {canOverride ? (
        <button
          type="button"
          className="btn"
          style={{ fontSize: 12, padding: '6px 10px' }}
          onClick={() => onOverride?.(gate)}
        >
          تجاوز يدوي
        </button>
      ) : null}
    </div>
  );
}
